import { render, staticRenderFns } from "./NewsCategoryEdit.vue?vue&type=template&id=51791abc&scoped=true&"
import script from "./NewsCategoryEdit.vue?vue&type=script&lang=js&"
export * from "./NewsCategoryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51791abc",
  null
  
)

export default component.exports